import {
  CompanyAdapter,
  LocalAdapter,
} from "../../../models/interfaces/backendResponses";
import {
  ILoginError,
  ILoginForm,
  TCurrentView,
} from "../../../models/interfaces/interfaces";
import {
  LOGIN_FORM_INITIAL_ERRORS,
  LOGIN_FORM_INITIAL_VALUES,
} from "../../consts/loginForm";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import { getUserPermissions } from "@viuti/recursos";
import { validateTheLoginAdapter } from "../../../adapters/valideTheLogin/valideTheLogin.adapter";

const useInitialState = () => {
  const navigate = useNavigate();
  // SET INITIAL STATES
  const [loginForm, setLoginForm] = useState<ILoginForm>(
    LOGIN_FORM_INITIAL_VALUES
  );
  const [errorLoginForm, setErrorLoginForm] = useState<ILoginError>(
    LOGIN_FORM_INITIAL_ERRORS
  );
  const [currentView, setCurrentView] = useState<TCurrentView>(0);
  const [businessList, setBusinessList] = useState<CompanyAdapter[]>(null);
  const [loungesList, setLoungesList] = useState<LocalAdapter[]>(null);

  // ** VALIDATE THE LOCAL
  useEffect(() => {
    if (loginForm.businessId === null) return;
    //get the lounges
    const lounges = businessList.find(
      (n) => n.businessId === loginForm.businessId
    );
    setLoungesList(lounges.lounges);
    setTimeout(() => {
      setCurrentView(2);
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginForm]);

  // ** GET THE TOKEN
  useEffect(() => {
    if (!(loginForm.businessId !== null && loginForm.loungeId !== null)) return;
    validateTheLoginAdapter(
      loginForm.email,
      loginForm.password,
      loginForm.businessId,
      loginForm.loungeId
    ).then((res) => {
      if (res.isSuccess) {
        const perms = getUserPermissions();
        const dest = perms?.startView || "/cajas";
        // Full page reload para que App.tsx re-evalúe isAuthenticated
        window.location.href = dest;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginForm]);

  return {
    loginForm,
    setLoginForm,
    errorLoginForm,
    setErrorLoginForm,
    currentView,
    setCurrentView,
    businessList,
    setBusinessList,
    loungesList,
    setLoungesList,
  };
};

export default useInitialState;
